type BackgroundSource = {
  src: any;
  startTime: number;
  sourceType?: 'video';
};

type CachedBackground = {
  value: BackgroundSource | any;
  signature: string;
};

class BackgroundControl {
  cacheMap: Record<string, CachedBackground> = {};
  activeSignature: string | null = null;

  private getSignature(id: string, sourceData: any, startTime: number) {
    const source =
      sourceData && typeof sourceData === 'object'
        ? JSON.stringify(sourceData)
        : String(sourceData ?? '');

    return `${id}:${startTime}:${source}`;
  }

  enter(data: {
    id: string;
    src: string;
    startTime: number;
    endTime: number;
    time: number;
    setBackgroundImage: (imageData: any) => void;
    imageData: any;
    videoData?: any;
  }) {
    const { id, imageData, videoData, setBackgroundImage, startTime } = data;
    const sourceData = videoData || imageData;
    const isVideo =
      Boolean(videoData) ||
      (typeof sourceData === 'string' &&
        (/\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(sourceData) ||
          /^data:video\//i.test(sourceData)));
    const backgroundImage = isVideo
      ? { src: sourceData, startTime, sourceType: 'video' as const }
      : sourceData;
    const signature = this.getSignature(id, sourceData, startTime);
    const cachedBackground = this.cacheMap[id];
    const nextBackground =
      cachedBackground?.signature === signature
        ? cachedBackground.value
        : backgroundImage;

    if (cachedBackground?.signature !== signature) {
      this.cacheMap[id] = {
        value: backgroundImage,
        signature,
      };
    }

    if (this.activeSignature !== signature) {
      setBackgroundImage(nextBackground);
      this.activeSignature = signature;
    }
  }

  leave(data: {
    id: string;
    startTime: number;
    endTime: number;
    time: number;
    setBackgroundImage: (imageData: any) => void;
  }) {
    //@ts-ignore
    const { time, startTime, endTime, setBackgroundImage } = data;
    if (time > endTime || time < startTime) {
      // temporary change to allow for multiple scene play with same background images
      //setBackgroundImage(null);
    }
  }

  destroy() {
    this.cacheMap = {};
    this.activeSignature = null;
  }
}

export default new BackgroundControl();
